module.exports = __webpack_public_path__ + "static/img/1.6120d50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/1.png
// module id = T4vJ
// module chunks = 1